import React from 'react';
export function AudienceLeaveIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), React.createElement("g", {
    clipPath: "url(#svg__6efe3__clip0)"
  }, React.createElement("path", {
    d: "M10.06 15.437c1.153-.541 2.11-1.445 2.791-2.586l-1.469-1.469C10.585 13.034 9.107 14 7.5 14 5.11 14 3 11.86 3 8.5c0-1.71.489-3.108 1.248-4.039C4.973 3.573 6.028 3 7.5 3c1.473 0 2.527.573 3.252 1.461.086.106.169.218.248.336V2.008C10.041 1.367 8.868 1 7.5 1 3.364 1 1 4.358 1 8.5c0 3.13 1.547 5.813 3.94 6.937-.219.734-1.01 1.027-1.897 1.356C1.641 17.313 0 17.922 0 20.5V23h15v-2.5c0-2.578-1.641-3.187-3.043-3.707-.887-.329-1.678-.622-1.897-1.356z"
  }), React.createElement("path", {
    d: "M15.5 14c1.394 0 2.692-.728 3.532-2h2.258c-.512 1.166-1.28 2.15-2.241 2.85.058.177.17.298.332.42.272.204.607.35 1.077.556.138.06.289.126.452.2.645.29 1.443.69 2.063 1.404.65.747 1.027 1.74 1.027 3.07V23h-6v-2h4v-.5c0-.92-.248-1.427-.536-1.758-.317-.365-.769-.62-1.374-.893l-.313-.137c-.499-.215-1.117-.483-1.596-.842a2.903 2.903 0 01-.927-1.124A6.068 6.068 0 0115.5 16c-.68 0-1.324-.108-1.925-.309.435-.544.817-1.138 1.14-1.77.257.053.52.079.785.079zM15 3l5.187-.223L13.5 9l1.5 1.5 6.223-6.687L21 9h2V1h-8v2z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "svg__6efe3__clip0"
  }, React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))));
}